export const blurButtonAfterClick = (buttonRef: React.RefObject<HTMLButtonElement>, callback: () => void) => {
  callback();
  if (buttonRef.current) {
    buttonRef.current.blur();
  }
};
